<template>
  <div class="user-message">
    <el-card>
      <template slot="header">
        <div class="card-header">
          <span>用户消息管理</span>
          <el-button type="primary" @click="handleSendMessage">发送消息</el-button>
        </div>
      </template>
      <el-table :data="messageList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="user_id" label="用户ID" width="120" />
        <el-table-column prop="title" label="消息标题" width="200" />
        <el-table-column prop="content" label="消息内容" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            {{ scope.row.status === 1 ? '已读' : '未读' }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="发送时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" @click="handleView(scope.row.id)">查看</el-button>
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- 发送消息对话框 -->
    <el-dialog :visible.sync="sendDialogVisible" title="发送消息" width="600px">
      <el-form :model="sendForm" :rules="sendRules" ref="sendForm">
        <el-form-item label="用户ID" prop="user_id">
          <el-input v-model="sendForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="消息标题" prop="title">
          <el-input v-model="sendForm.title" placeholder="请输入消息标题"></el-input>
        </el-form-item>
        <el-form-item label="消息内容" prop="content">
          <el-input v-model="sendForm.content" type="textarea" rows="4" placeholder="请输入消息内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitSendMessage">发送</el-button>
      </div>
    </el-dialog>

    <!-- 消息详情对话框 -->
    <el-dialog :visible.sync="detailDialogVisible" title="消息详情" width="600px">
      <el-form :model="messageDetail" label-width="100px">
        <el-form-item label="用户ID">
          <el-input v-model="messageDetail.user_id" disabled></el-input>
        </el-form-item>
        <el-form-item label="消息标题">
          <el-input v-model="messageDetail.title" disabled></el-input>
        </el-form-item>
        <el-form-item label="消息内容">
          <el-input v-model="messageDetail.content" type="textarea" rows="4" disabled></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input :value="messageDetail.status === 1 ? '已读' : '未读'" disabled></el-input>
        </el-form-item>
        <el-form-item label="发送时间">
          <el-input v-model="messageDetail.created_at" disabled></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UserMessage',
  data() {
    return {
      messageList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sendDialogVisible: false,
      detailDialogVisible: false,
      sendForm: {
        user_id: '',
        title: '',
        content: ''
      },
      sendRules: {
        user_id: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
        title: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
      },
      messageDetail: {}
    }
  },
  mounted() {
    this.fetchMessageList()
  },
  methods: {
    fetchMessageList() {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/message/list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.messageList = data.data.list
          this.total = data.data.total
        }
      })
      .catch(() => {
        this.$message.error('获取消息列表失败')
      })
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchMessageList()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchMessageList()
    },
    handleSendMessage() {
      this.sendForm = {
        user_id: '',
        title: '',
        content: ''
      }
      this.sendDialogVisible = true
    },
    submitSendMessage() {
      this.$refs.sendForm.validate(valid => {
        if (valid) {
          const token = localStorage.getItem('adminToken')
          fetch('/api/admin/message/send', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.sendForm)
          })
          .then(response => response.json())
          .then(data => {
            if (data.code === 0) {
              this.$message.success('发送成功')
              this.sendDialogVisible = false
              this.fetchMessageList()
            } else {
              this.$message.error(data.message || '发送失败')
            }
          })
          .catch(() => {
            this.$message.error('发送失败')
          })
        }
      })
    },
    handleView(id) {
      const token = localStorage.getItem('adminToken')
      fetch(`/api/admin/message/detail/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          this.messageDetail = data.data
          this.detailDialogVisible = true
        }
      })
      .catch(() => {
        this.$message.error('获取消息详情失败')
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除这条消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/message/delete/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchMessageList()
          } else {
            this.$message.error(data.message || '删除失败')
          }
        })
        .catch(() => {
          this.$message.error('删除失败')
        })
      })
      .catch(() => {})
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.user-message {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>